<template>
  <div class="_avatar_pmg1v_1" style="position: relative;">
    <img
      :src="market.quoteAsset.icon"
      alt="ارز"
      loading="lazy"
      decoding="async"
      style="left: -20%; top: -20%; position: absolute"
      class="_avatar_pmg1v_1 _md_pmg1v_22"
    />
    <img
      :src="market.baseAsset.icon"
      alt="ارز"
      loading="lazy"
      decoding="async"
      style="left: 20%; top: 20%; position: absolute"
      class="_avatar_pmg1v_1 _md_pmg1v_22"
    />
  </div>
</template>

<script>
import { Market } from './market'

export default {
  props: {
    market: {
      type: Market,
      required: true
    }
  }
}
</script>

<style>
</style>